import { NavLink } from "react-router-dom"
import { Button } from "primereact/button"
import userContext, { UserRole } from "../../context/userContext"
import { useContext } from "react"

export default function TaskListControls({
  exportHandler,
  showMassActions = false,
  taskType,
}) {
  const { hasRole } = useContext(userContext)

  return (
    <div className={"col-12"}>
      <div className={"flex"}>
        {!hasRole(UserRole.Pracovnik) && !hasRole(UserRole.TzvPracovnik) && (
          <NavLink to={"/task/prevention"} className={"p-button mr-1"}>
            Nová pravidelná údržba
          </NavLink>
        )}

        <NavLink to={"/task/report"} className={"p-button mr-1"}>
          Nové hlášení
        </NavLink>

        {!hasRole(UserRole.Pracovnik) && !hasRole(UserRole.TzvPracovnik) && showMassActions && (
          <NavLink to={"/task/prevention/bulk"} className={"p-button p-button-secondary mr-1"}>
            Hromadné akce
          </NavLink>
        )}

        {taskType === "PREVENTION" ? (
          <NavLink to={"/task/prevention/remind"} className={"p-button p-button-secondary mr-1"}>
            Připomenout
          </NavLink>
        ) : (
          <NavLink to={"/task/report/remind"} className={"p-button p-button-secondary mr-1"}>
            Připomenout
          </NavLink>
        )}

        <Button className={"p-button-sm p-button-secondary ml-auto"}
          onClick={exportHandler}>Export</Button>
      </div>
    </div>
  )
}
